<template>
  <v-container>
    <v-row>
      <v-col>
        <section aria-label="Featured services carousel">
          <v-carousel class="topCarousel" cycle hide-delimiter-background>
            <v-carousel-item
              v-for="item in this.CarouselItems"
              :key="item.id"
              :src="getImg(item.image)"
              @click="navigateToLink(item.url)"
              eager
            >
              <v-img :src="getImg(item.image)" height="100%" eager>
                <v-row class="fill-height" align="center" justify="center">
                  <v-row
                    class="carouselTextDiv fill-height carouselTextBackground"
                    justify="center"
                    align="center"
                    style="height: 100px"
                  >
                    <v-col
                      v-if="item.logo"
                      cols="4"
                      md="2"
                      justify="right"
                      align="center"
                      style="height: 100px; background-color: clear"
                    >
                      <embed
                        :src="getImg(item.logo)"
                        alt="logo"
                        style="width: 85%; height: 85%"
                      />
                    </v-col>
                    <v-col
                      cols="4"
                      md="6"
                      class="text-center"
                      style="font-family: 'Permian Slab', serif; letter-spacing: -0.075em; background-color: clear"
                    >
                      {{ englishLang[item.name] }}
                    </v-col>
                  </v-row>
                </v-row>
              </v-img>
            </v-carousel-item>
          </v-carousel>
        </section>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import EnglishLang from "../../../public/languages/English.json";

export default {
  name: "TopCarousel",
  data: function() {
    return {
      CarouselItems: [],
      englishLang: EnglishLang
    };
  },
  methods: {
    navigateToLink: function(link) {
      window.open(link);
    },
    getImg: function(file) {
      if (file == null || file == "") {
        return "";
      }

      if (file.includes("/")) {
        //This assumes file is a url
        return file;
      } else {
        return require("../../assets/images/" + file);
      }
    },
    readInItems: function() {
      axios.get("./landing-page/TopCarousel.json").then(response => {
        this.CarouselItems = response.data;
      });
    }
  },

  mounted: function() {
    this.readInItems();
  }
};
</script>

<style scoped lang="scss">
.topCarousel {
  justify-content: center;
  text-align: start;
  width: 1200px;
}
.carouselTextBackground {
  width: 100%;
  background-color: rgba(88, 88, 88, 0.5);
}
.carouselTextDiv {
  color: white;
  opacity: 1;
}
.carouselLogo {
  height: 100px;
  width: 200px;
}
@media (min-width: 1264px) {
  .container {
    max-width: 1100px !important;
  }
  .carouselTextDiv {
    font-size: 40px;
  }
}
@media (min-width: 961px) and (max-width: 1263px) {
  .carouselTextDiv {
    font-size: 30px;
  }
}
@media (min-width: 601px) and (max-width: 960px) {
  .carouselTextDiv {
    font-size: 25px;
  }
}
@media (max-width: 600px) {
  .carouselTextDiv {
    font-size: 18px;
  }
}
</style>
